module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vux-demo-header-box",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('x-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headShow),
      expression: "headShow"
    }],
    attrs: {
      "left-options": {
        backText: ''
      }
    }
  }, [_vm._v(_vm._s(_vm.pageTitle))])], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('van-search', {
    attrs: {
      "placeholder": "请输入搜索关键词"
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._l((_vm.paginatedData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zx-task-box",
      on: {
        "click": function($event) {
          return _vm.listDes(item)
        }
      }
    }, [_c('div', {
      staticClass: "zx-task-box-title"
    }, [_c('div', {
      staticStyle: {
        "margin-left": "5px"
      }
    }, [(item.demand.includes('点赞')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v(" 点赞  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('转发')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v(" 转发  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('在看')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "success",
        "color": "blue"
      }
    }, [_vm._v(" 在看  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('评论')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "warning",
        "color": "grey"
      }
    }, [_vm._v(" 评论  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('举报')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "danger",
        "color": "red"
      }
    }, [_vm._v(" 举报  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('关注')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "danger",
        "color": "red"
      }
    }, [_vm._v(" 关注  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('投票')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "danger",
        "color": "red"
      }
    }, [_vm._v(" 投票  ")])], 1) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "zx-task-box-des"
    }, [_vm._v("\n            任务名称："), _c('div', {
      staticStyle: {
        "color": "grey",
        "margin-bottom": "1px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" \n            结束时间："), _c('div', {
      staticStyle: {
        "color": "grey",
        "margin-bottom": "10px"
      }
    }, [_vm._v(" " + _vm._s(item.endtime))])])])
  }), _vm._v(" "), _c('van-pagination', {
    attrs: {
      "page-count": _vm.pageCount
    },
    on: {
      "change": _vm.handlePageChange
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 2), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "任务详情"
    },
    model: {
      value: (_vm.infoShow),
      callback: function($$v) {
        _vm.infoShow = $$v
      },
      expression: "infoShow"
    }
  }, [_c('van-cell-group', {
    staticClass: "asd",
    style: (_vm.test)
  }, [_c('div', {
    staticStyle: {
      "margin-left": "5px"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label-class": "label",
      "label": "任务名称:",
      "value": _vm.tanchukuang.title,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "开始时间:",
      "value": _vm.tanchukuang.starttime,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "结束时间:",
      "value": _vm.tanchukuang.endtime,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "任务需求:",
      "value": _vm.tanchukuang.demand,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "备注信息:",
      "value": _vm.tanchukuang.message,
      "readonly": ""
    }
  }), _vm._v(" "), _c('div', _vm._l((_vm.urls), function(item, index) {
    return _c('van-field', {
      key: index,
      attrs: {
        "error": "",
        "size": "large",
        "label": "点击跳转:",
        "value": item,
        "readonly": ""
      },
      on: {
        "click": function($event) {
          return _vm.open(item)
        }
      }
    })
  }), 1), _vm._v(" "), (_vm.dianzan(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "点赞示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist),
            callback: function($$v) {
              _vm.filelist = $$v
            },
            expression: "filelist"
          }
        })]
      },
      proxy: true
    }], null, false, 2136404113)
  }) : _vm._e(), _vm._v(" "), (_vm.zaikan(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "在看示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist1),
            callback: function($$v) {
              _vm.filelist1 = $$v
            },
            expression: "filelist1"
          }
        })]
      },
      proxy: true
    }], null, false, 2313403904)
  }) : _vm._e(), _vm._v(" "), (_vm.zhuangfa(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "转发示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist2),
            callback: function($$v) {
              _vm.filelist2 = $$v
            },
            expression: "filelist2"
          }
        })]
      },
      proxy: true
    }], null, false, 4142773635)
  }) : _vm._e(), _vm._v(" "), (_vm.pinglun(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "评论示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist3),
            callback: function($$v) {
              _vm.filelist3 = $$v
            },
            expression: "filelist3"
          }
        })]
      },
      proxy: true
    }], null, false, 393317890)
  }) : _vm._e(), _vm._v(" "), (_vm.jubao(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "举报示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist4),
            callback: function($$v) {
              _vm.filelist4 = $$v
            },
            expression: "filelist4"
          }
        })]
      },
      proxy: true
    }], null, false, 593878405)
  }) : _vm._e(), _vm._v(" "), (_vm.guanzhu(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "关注示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist5),
            callback: function($$v) {
              _vm.filelist5 = $$v
            },
            expression: "filelist5"
          }
        })]
      },
      proxy: true
    }], null, false, 2974227716)
  }) : _vm._e(), _vm._v(" "), (_vm.toupiao(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "投票示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist6),
            callback: function($$v) {
              _vm.filelist6 = $$v
            },
            expression: "filelist6"
          }
        })]
      },
      proxy: true
    }], null, false, 508630151)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('van-button', {
    staticStyle: {
      "width": "100px",
      "height": "40px",
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.tiao(_vm.tanchukuang.title, _vm.tanchukuang.id, _vm.tanchukuang.demand, _vm.tanchukuang.bumen, _vm.urls)
      }
    }
  }, [_vm._v("提交任务")])], 1)], 1)], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "完成情况"
    },
    model: {
      value: (_vm.infoShow1),
      callback: function($$v) {
        _vm.infoShow1 = $$v
      },
      expression: "infoShow1"
    }
  }, [_c('van-cell-group', {
    staticClass: "asd",
    style: (_vm.test)
  }, [_c('van-field', {
    attrs: {
      "size": "large",
      "label-class": "label",
      "label": "任务名称:",
      "value": _vm.tanchukuang.title,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "任务需求:",
      "value": _vm.tanchukuang.demand,
      "readonly": ""
    }
  }), _vm._v(" "), (this.sfxs === 2) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "退回原因:",
      "value": _vm.tanchukuang.message,
      "readonly": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.urls), function(item, index) {
    return _c('van-field', {
      key: index,
      attrs: {
        "error": "",
        "size": "large",
        "label": "点击跳转:",
        "value": item,
        "readonly": ""
      },
      on: {
        "click": function($event) {
          return _vm.open(item)
        }
      }
    })
  }), 1), _vm._v(" "), (this.sfxs === 2) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "备注信息:",
      "value": _vm.tanchukuang.message,
      "readonly": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dianzan(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 点赞照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.likedfile),
            callback: function($$v) {
              _vm.likedfile = $$v
            },
            expression: "likedfile"
          }
        })]
      },
      proxy: true
    }], null, false, 2193490940)
  }) : _vm._e(), _vm._v(" "), (_vm.zaikan(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 在看照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.watchingfile),
            callback: function($$v) {
              _vm.watchingfile = $$v
            },
            expression: "watchingfile"
          }
        })]
      },
      proxy: true
    }], null, false, 4171700634)
  }) : _vm._e(), _vm._v(" "), (_vm.zhuangfa(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 转发照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.transmitfile),
            callback: function($$v) {
              _vm.transmitfile = $$v
            },
            expression: "transmitfile"
          }
        })]
      },
      proxy: true
    }], null, false, 684305561)
  }) : _vm._e(), _vm._v(" "), (_vm.pinglun(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 评论照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.commentfile),
            callback: function($$v) {
              _vm.commentfile = $$v
            },
            expression: "commentfile"
          }
        })]
      },
      proxy: true
    }], null, false, 2709869664)
  }) : _vm._e(), _vm._v(" "), (_vm.jubao(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 举报照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.reportfile),
            callback: function($$v) {
              _vm.reportfile = $$v
            },
            expression: "reportfile"
          }
        })]
      },
      proxy: true
    }], null, false, 3331167549)
  }) : _vm._e(), _vm._v(" "), (_vm.guanzhu(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 关注照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.gzfile),
            callback: function($$v) {
              _vm.gzfile = $$v
            },
            expression: "gzfile"
          }
        })]
      },
      proxy: true
    }], null, false, 3001380174)
  }) : _vm._e(), _vm._v(" "), (_vm.toupiao(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 投票照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.tpfile),
            callback: function($$v) {
              _vm.tpfile = $$v
            },
            expression: "tpfile"
          }
        })]
      },
      proxy: true
    }], null, false, 610093111)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(this.sfxs === 2) ? _c('van-button', {
    staticStyle: {
      "width": "100px",
      "height": "40px",
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.tiao(_vm.tanchukuang.title, _vm.tanchukuang.id, _vm.tanchukuang.demand, _vm.tanchukuang.bumen, _vm.urls)
      }
    }
  }, [_vm._v("提交任务")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zx-task-box-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/xin/rwtz.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b415fb4e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dtask.vue
// module id = 541
// module chunks = 1